/**
 * @readonly
 * @enum
 */
export const SpriteTypes = {
    "sprite": 'Sprite',
    "label": 'Label',
}

/**
 * 工具类型
 * @readonly
 * @enum
 */
export const ToolsTypes = {
    "Pen":"Pen",
    "Anchors": 'Anchors',
    "Line":"Line",
    "Arrow":"Arrow"
}

/**
 * 画笔分类
 * @readonly
 * @enum
 */
export const spriteCategory = {
    "pool": 'pool',
    "pipe": 'pipe',
    "line": 'line',
    "accessories": 'accessories',
    "valve":'valve',
    "bg":'bg',
    "from":"from",
    "charts":"charts"
}

/**
 * 属性类型
 * @readonly
 * @enum
 * @property {string} color 颜色
 * @property {string} eumn 枚举类型
 * @property {string} number 数字
 * @property {string} switch 开关，布尔值
 * @property {string} string 字符串，用于输入框
 * @property {string} json json类型，打开编辑器操作
 * @property {string} slider 滑动条
 * @property {string} code 代码类型，打开编辑器操作
 */
export const propsTypes ={
    "color": 'Color',
    "eumn": 'Enum', 
    "number": 'Number',
    "switch": 'Switch', 
    "string": 'String', 
    "json":'Json', 
    "slider":"Slider", 
    "code":"Code", 
}

/**
 * 事件类型
 * @readonly
 * @enum
 */
export const eventType = {
    "enter":"enter",
    "leave":"leave",
    "active":"active",
    "inactive":"inactive",
    "click":"click",
    "dblclick":"dblclick",
    "mousedown":"mousedown",
    "mouseup":"mouseup",
    "valueUpdate":"valueUpdate",
    "init":"init",
    "listener":'listener',
}

/**
 * 执行动作
 * @readonly
 * @enum
 */
export const EventAction = {
    "None":-1,
    "Link":0,
    "SetProps":1,
    "StartAnimate":2,
    "PauseAnimate":3,
    "StopAnimate":4,
    "Function":5,
    "WindowFn":6,
    "Emit":7,
    "StartVideo":8,
    "PauseVideo":9,
    "StopVideo":10,
  }

  /**
   *   条件类型 
   * @readonly
 * @enum
   */
  export const Comparison = {
    // 等于
    "Equal":"==",
    // 不等于
    "NotEqual":"!=",
    // 大于
    "GreaterThan":">",
    // 小于
    "LessThan":"<",
    // 大于等于
    "GreaterThanOrEqual":">=",
    // 小于等于
    "LessThanOrEqual":"<=",
    // 包含
    "Contains":"[]",
    // 不包含
    "NotContains":"![]",
    // 介于
    "Between":"[)",
    // 不介于
    "NotBetween":"![)",
  }

/**
 * 动画类型
 * @readonly
 * @enum
 */

export const AnimationType = {
    "none":0,
    "rotate":1,
    "sucess":2,
    "error":3,
    "upDown":4,
    "leftRight":5,
    "custom":6
}

/**
 * 线条动画类型
 * @readonly
 * @enum
 */
export const lineAnimationType = {
    "none":null,
    "flow":0, //流水
    "dottedLine":1, //虚线
    "dot":2 //圆点
}

/**
 * 添加的数据类型,用于处理数据结构,如果是编辑器中显示的内容请使用propsTypes,
 * @readonly
 * @enum
 */
export const dataType = {
    "text":"text",
    "number":"number",
    "color":"color",
    "textarea":"textarea",
    "downselect":"downselect",
    "swicth":"swicth",
    "json":"json",
    "slide":"slide",
    "code":'code',
}

